<template>
  <div :class="$style.sectionIndustry">
    <div class="container section">
      <p class="dingbeauty-sub-title fancy-title">Industry</p>
      <h2 class="dingbeauty-title is-dotted">愛美訂適用產業</h2>
      <div class="industry-container--mobile">
        <div class="industry-item" v-for="(item, index) in industries" :key="index">
          <div class="item-bg" :style="{ 'background-image': `url(${item.img})`, 'background-position': item.mobilePosition }"></div>
          <div style="padding: 18px;">
            <p class="content-title">{{ item.title }}</p>
            <p class="content-description">{{ item.description }}</p>
          </div>
        </div>
      </div>
      <div class="industry-container--pc">
        <div class="industry-item" v-for="(item, index) in industries" :key="index" :style="{ 'background-image': `url(${item.img})` }">
          <div class="item-content">
            <p class="content-title">{{ item.title }}</p>
            <p class="content-description">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      industries: [
        {
          img: require('@assets/dingbeauty-images/home/industry_01@1.png'),
          title: '美體護膚',
          description: '可設定多種課程組合，滿足客戶各種需求的全方位美容方案，讓您提供更具吸引力的美體護膚服務',
          mobilePosition: 'center 30%',
        },
        {
          img: require('@assets/dingbeauty-images/home/industry_02@1.png'),
          title: 'SPA按摩',
          description: '提供獨家跨日預約功能，提高客戶預約的彈性，讓24小時營業店家不再擔心，有效提升營運效能',
          mobilePosition: 'center 44%',
        },
        {
          img: require('@assets/dingbeauty-images/home/industry_03@1.png'),
          title: '時尚美髮',
          description: '個性化美容師服務費用，讓您巧妙調整價格，滿足客戶不同的需求，並提升銷售策略的多樣性',
          mobilePosition: 'center 41%',
        },
        {
          img: require('@assets/dingbeauty-images/home/industry_04@1.png'),
          title: '美甲美睫',
          description: '我們提供多元預約方式，減少店家忙碌時的干擾，讓您更專注美麗本身，提升工作效率',
          mobilePosition: 'center 30%',
        },
        {
          img: require('@assets/dingbeauty-images/home/industry_05@1.png'),
          title: '專業醫美',
          description: '讓您擁有一站式的會員管理，提高客戶管理效率，方便隨時記錄個別化的醫美計畫，促進業務增長',
          mobilePosition: 'center 92%',
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
$color-primary: #d8b37f;
.sectionIndustry {
  :global {
    .industry-container--mobile {
      display: grid;
      gap: 20px;

      .industry-item {
        border: 1px solid #e5e1db;
        text-align: center;

        .item-bg {
          height: 120px;
          background-size: cover;
        }

        .content-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 14px;
        }

        .content-description {
          font-size: 13px;
          line-height: 1.7;
          margin: 0;
        }
      }
    }

    .industry-container--pc {
      display: none;
      flex-wrap: wrap;
      justify-content: center;

      .industry-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        color: #fff;
        position: relative;
        width: 100%;
        height: 400px;
        background-position: center;
        padding: 20px;
        flex-grow: 1;
        z-index: 4;
        max-width: 400px;

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          background-color: rgba($color: #000000, $alpha: 0.2);
          width: 100%;
          height: 100%;
        }

        .item-content {
          position: relative;
          z-index: 3;

          .content-title {
            font-size: 20px;
            margin-bottom: 8px;
            text-align: center;
          }

          .content-description {
            font-size: 16px;
            margin-bottom: 0;
            text-align: center;
          }
        }
      }
    }
  }
}

@media (min-width: 576px) {
  .sectionIndustry {
    :global {
      .industry-container--mobile {
        grid-template-columns: 1fr 1fr;
      }

      .industry-container--pc {
        gap: 0;

        .industry-item {
          width: 300px;
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .sectionIndustry {
    :global {
      .industry-container--mobile {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
}

@media (min-width: 1400px) {
  .sectionIndustry {
    :global {
      .industry-container--mobile {
        display: none;
      }

      .industry-container--pc {
        display: flex;
        flex-wrap: nowrap;

        .industry-item {
          position: relative;
          height: 600px;
          flex: 1;
          transition: all 0.3s;

          .content-title {
            width: 360px;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            transition: all 0.3s;
          }

          .content-description {
            position: absolute;
            font-size: 16px;
            margin-bottom: 0;
            transition: all 0.3s;
            width: 360px;
            left: 0;
            bottom: 0;
            opacity: 0;
          }

          &:hover {
            flex-grow: 4;

            .content-title {
              bottom: 68px;
              text-align: left;
              margin-bottom: 16px;
            }

            .content-description {
              height: auto;
              opacity: 1;
              text-align: left;
              line-height: 1.7;
            }
          }
        }
      }
    }
  }
}
</style>
